<template>
  <div class="features-ability">
    <div class="features-ability-max">
      <!-- 功能 -->
      <div class="features-ability-total">
        <p class="total_title gradient-color">全流程数字化赋能</p>
        <p class="total_desc">九大环节一步到位 转型升级很简单</p>
        <div class="img-container">
          <img
            class="total_img"
            src="@/assets/images/productFeatures/bg_process.png"
            alt=""
          />
        </div>
      </div>
      <div
        v-for="(item, index) in modules"
        :key="index"
        class="module-box module-box-flex"
        :class="{ 'module-box_two': index % 2 !== 0 }"
      >
        <div class="box-text pt-0">
          <p class="gradient-color box-text-title">{{ item.title }}</p>
          <div
            v-for="(subItem, subIndex) in item.subTitle"
            :key="subIndex"
            class="box-text-title_sub"
          >
            <img
              src="@/assets/images/productFeatures/success-fill.png"
              alt=""
            />
            <p>{{ subItem }}</p>
          </div>
        </div>
        <div class="box-img">
          <div class="box-img-container">
            <img :src="item.img" :alt="item.title" class="image" />
          </div>
        </div>
      </div>
    </div>

    <div class="features-ability-ai">AI提效+数据降本<br />让纸箱厂利润飙升</div>

    <div class="features-ability-max">
      <div class="module-box  advantages-box">
        <div class="box-text">
          <p class="gradient-color box-text-title text-center">
            全端同步，生产尽在掌握
          </p>
          <p class="box-text-title_desc">
            打破空间限制，支持Web、App、小程序多端实时数据同步。无论您身在何处，工厂产量、进度、设备状态等关键数据一手掌握，助力您随时随地精准决策，大幅提升管理效率
          </p>
        </div>
        <div class="box-img">
          <div class="box-img-container">
            <img
              class="image"
              src="@/assets/images/productFeatures/bg_client.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="module-box module-box-flex  aiborder-module">
        <div class="box-text aiborder-box-text">
          <p class="box-text-title">AI智能买纸板</p>
          <p class="box-text-title_desc card-sum-desc">
            只需手机拍照或上传文件，瞬间识别生成规范表格，一键自动下单。告别微信、电话反复沟通的传统低效方式，订单处理速度提升20倍，准确又省力。让纸板采购变得如此简单！
          </p>
        </div>
        <div class="box-img">
          <div class="box-img-container">
            <img
              class="image"
              src="@/assets/images/productFeatures/bg_ai_intelligent.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="flex-box">
        <div class="module-box flex-1 mr0">
          <div class="box-text text-flex1">
            <p class="gradient-color box-text-title">送货记账</p>
            <p class="box-text-title_desc">
              AI提效+数据降本，智能管理让纸箱厂利润飙升！
            </p>
          </div>
          <div class="box-img">
            <div class="box-img-container">
              <img
                class="image"
                src="@/assets/images/productFeatures/bg_delivery.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="module-box flex-1 ml0">
          <div class="box-text text-flex1">
            <p class="gradient-color box-text-title">价格自动算，省心更精准</p>
            <p class="box-text-title_desc">
              支持各类箱型，可完全自定义结算公式。输入参数后，系统立即自动算出精准纸箱单价，透明无误差，告别繁琐手工计算，高效省心。
            </p>
          </div>
          <div class="box-img">
            <div class="box-img-container">
              <img
                class="image"
                src="@/assets/images/productFeatures/bg_calc.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-diffimg"></div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      modules: [
        {
          title: '客户管理',
          subTitle: [
            '客户统一管理，避免资料丢失',
            '客户账期授信预警，系统自动提醒',
            '财务灵活设置，账单自动生成'
          ],
          img: require('@/assets/images/productFeatures/bg_customer.png')
        },
        {
          title: '产品管理',
          subTitle: [
            '精确管理每个客户的每个产品',
            '自动计算纸箱成本和毛利',
            '关联图纸，自动为生产提供依据',
            '实现按材料/产品批量调价，提高效率，避免出错'
          ],
          img: require('@/assets/images/productFeatures/bg_product.png')
        },
        {
          title: '纸板采购',
          subTitle: [
            '根据订单自动生成采购单',
            '采购单状态全流程可视',
            '支持多渠道采购，统一管理'
          ],
          img: require('@/assets/images/productFeatures/bg_buy.png')
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.features-ability {
  width: 100%;
  // padding-bottom: 64px;

  // margin: 0 60px;
  // height: 417px;
  // display: grid;
  // grid-template-rows: auto;
  // gap: 32px;
  .gradient-color {
    background: linear-gradient(90deg, #009df7 0%, #0064eb 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent !important;
  }
  .text-center {
    text-align: center;
  }
  .height-auto {
    height: auto;
  }
  .flex-1 {
    flex: 1;
  }
  img {
    object-fit: contain;
  }
  .features-ability-max {
    max-width: 1200px;
    margin: 0 auto;
  }

  .features-ability-total {
    text-align: center;
    // margin-bottom: 32px;
    margin: 0 30px 32px;
    .total_title {
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-size: 32px;
      color: #000000;
      margin-top: 32px;
    }
    .total_desc {
      // font-family: AlibabaPuHuiTi_2_85_Bold;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      margin-top: 16px;
    }
    .img-container {
      // padding: 28px 30px 0;
      width: 100%;
      box-sizing: border-box;

      background: #ffffff;
      border-radius: 16px;
      display: flex;
      margin-top: 100px;
      .total_img {
        width: 100%;
        height: auto;
        // height: 543px;
        display: block;
        object-fit: contain;
        // max-height: 500px;
        margin-top: -80px;
      }
    }
  }
  .module-box {
    // margin: 0 60px;
    background: #ffffff;
    box-shadow: 0px 0 15px 0px rgba(0, 0, 0, 0.07);
    border-radius: 16px;
    margin: 0 30px 32px;
    display: flex; /* 确保使用flex布局 */
    align-items: stretch; /* 让子元素撑满高度 */
    flex-direction: column;
    .box-text {
      font-family: AlibabaPuHuiTi_2_85_Bold;
      padding: 32px 12px 0 16px;
      // flex: 1;
      // padding: 0 40px;
      &-title {
        font-size: 32px;
      }
      &-title_sub {
        margin-top: 24px;
        display: flex;
        align-items: flex-start;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }
        p {
          font-size: 24px;
          color: #666666;
          margin-left: 8px;
        }
      }
      &-title_desc {
        font-size: 24px;
        color: #333333;
        margin-top: 24px;
      }
    }
    .box-img {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      // padding: 13px;
      .box-img-container {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }
      .image {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        max-height: 600px;
      }
    }
  }

  .features-ability-ai {
    height: 318px;
    background-image: url('../../../assets/images/productFeatures/bg_ai.png');
    background-position: center;
    background-size: cover;
    font-size: 40px;
    color: #ffffff;
    margin-top: 64px;
    padding-top: 81px;
    text-align: center;
    margin: 0;
  }
  .advantages-box {
    margin-top: 32px;
  }
  .aiborder-module {
    color: #ffffff;
    background: linear-gradient(181deg, #5c258d 0%, #4389a2 100%);
    .card-sum-desc {
      color: #ffffff;
    }
  }

  .box-diffimg {
    margin-top: 32px;
    height: auto;
    min-height: 1850px;
    background-image: url('../../../assets/images/productFeatures/mobile-differ.png');
    background-position: center;
    background-size: cover;
    max-height: 1850px;
  }
}
@media (min-width: 751px) and (max-width: 960px) {
  .features-ability {
    // height: 417px;
    .features-ability-total {
      .img-container {
        .total_img {
          max-height: 400px;
        }
      }
    }
    .pt-0 {
      padding-top: 0 !important;
    }

    .module-box {
      /* 文字区域优化 */
      .box-text {
        flex: 0 0 48%;
        // padding: 0 32px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }
      .text-flex1 {
        flex: 1;
      }

      .box-img {
        flex: 0 0 48%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        // max-height: 650px;
      }
    }
    .module-box-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      // max-height: 800px;
      // min-height: 650px;
    }
    .module-box_two {
      flex-direction: row-reverse;
      padding: 10px 0;
    }
    .aiborder-module {
      display: flex;
      .aiborder-box-text {
        padding: 80px 0 80px 32px;
      }
    }

    .flex-box {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 48px;
      align-items: stretch;
      // margin: 0 60px;
      .ml0 {
        margin-left: 0;
      }
      .mr0 {
        margin-right: 0;
      }
    }
    .box-diffimg {
      min-height: 680px;
      background-image: url('../../../assets/images/productFeatures/web_differ.png');
    }
  }
}
@media (min-width: 961px) {
  .features-ability {
    // height: 417px;
    .features-ability-total {
      .img-container {
        .total_img {
          max-height: 400px;
        }
      }
    }
    .pt-0 {
      padding-top: 0 !important;
    }

    .module-box {
      /* 文字区域优化 */
      .box-text {
        flex: 0 0 48%;
        // padding: 0 32px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }
      .text-flex1 {
        flex: 1;
      }

      .box-img {
        flex: 0 0 48%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        // max-height: 650px;
      }
    }
    .module-box-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      // max-height: 800px;
      // min-height: 650px;
    }
    .module-box_two {
      flex-direction: row-reverse;
      padding: 10px 0;
    }
    .aiborder-module {
      display: flex;
      .aiborder-box-text {
        padding: 80px 0 80px 32px;
      }
    }

    .flex-box {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 48px;
      align-items: stretch;
      // margin: 0 60px;
      .ml0 {
        margin-left: 0;
      }
      .mr0 {
        margin-right: 0;
      }
    }
    .box-diffimg {
      min-height: 680px;
      background-image: url('../../../assets/images/productFeatures/web_differ.png');
    }
  }
}
</style>
